import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

export const rootRedirectGuard: CanActivateFn = (route, state): Observable<UrlTree> => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  return authService.getAuthState().pipe(
    take(1), // Complete after the first emission
    map(user => {
      if (user) {
        // User is logged in, redirect to AI Studio
        return router.createUrlTree(['/ai-studio']);
      } else {
        // User is not logged in, redirect to login page
        return router.createUrlTree(['/login']);
      }
    })
  );
};
